import React, { useState } from 'react';
import breakpoint from "../../helpers/breakpoints";

const LessonIcon = props => {
    const { src, text, link } = props;
    const [big, setBig] = useState(false)
    return <div onMouseEnter={() => setBig(true)} onMouseLeave={() => setBig(false)} style={{ height: '2.778rem', cursor: 'pointer' }}>
        <div style={{ display: 'flex', justifyContent: 'center' }} onClick={() => window.open(link)}>
            <img src={src} alt={text} style={big ? { height: '1.389rem', width: '1.389rem' } : { height: '1.111rem', width: '1.111rem' }} />
        </div>
        <div style={{ minWidth: ['S', 'XS'].includes(breakpoint()) ? '2.8rem' : '4.722rem', textAlign: 'center', opacity: '0.7' }}>{big ? text : ''}</div>
    </div>
}

export default LessonIcon;